import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const REMOVE_OFFER_PRICING_MUTATION = gql`
  mutation removeOfferPricing (
    $documentVersion: DocumentVersionInput!,
    $priceLineId: String!,
    $stepId: String!,
    $withPricing: Boolean = true
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        removePricingCommand(priceLineId: $priceLineId, stepId: $stepId) {
          id
          ...QuotePricingFragment @include(if: $withPricing)
          ...QuotePricingStateFragment @skip(if: $withPricing)
          lines {
            id
            ...ProductLinePricingFragment @include(if: $withPricing)
            ...CustomLinePricingFragment @include(if: $withPricing)
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${CUSTOM_LINE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class RemoveOfferPricingMutation extends Mutation<RootMutation> {
  document = REMOVE_OFFER_PRICING_MUTATION;
}
